var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06318 -3.66802e-07L4.5248 3.24494L7.98643 -4.88376e-08L9.0498 0.998988L4.5248 5.25L-0.000194591 0.998987L1.06318 -3.66802e-07Z",
    fill: "#90B529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowDown);
export default __webpack_public_path__ + "static/media/greenArrowDown.0e519c86cce4f95b6133b4a9556f4042.svg";
export { ForwardRef as ReactComponent };